// material
import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/system';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';

// ----------------------------------------------------------------------

interface LogoProps extends BoxProps {
  isOffset?: boolean;
}
// width: 42, height: 42

export default function LogoWhatsApp({ sx, isOffset = true }: LogoProps) {
  const { palette } = useTheme();
  const { event } = useGoogleTagManager();

  const mediaInteraction = (media: string) => {
    event({
      path: media,
      event: 'Contact'
    });
  };
  return (
    <Box
      sx={{
        width: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        height: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        ...sx
      }}
    >
      <a
        target={'_blank'}
        onClick={() => mediaInteraction('WhatsApp')}
        href="https://api.whatsapp.com/send?phone=525614128181&text=Hola,%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n."
        rel="noreferrer"
        aria-label="Icon send message WhatsApp"
      >
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21" cy="21" r="21" fill={palette.primary.main} />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.0478 12.6871C26.8785 10.5256 23.9935 9.33476 20.9199 9.3335C14.5866 9.3335 9.43227 14.4631 9.42972 20.7677C9.42887 22.7831 9.9579 24.7505 10.9634 26.4847L9.33334 32.4102L15.4245 30.82C17.1028 31.7311 18.9924 32.2113 20.9153 32.2118H20.9201C27.2527 32.2118 32.4076 27.0819 32.41 20.7769C32.4113 17.7213 31.2172 14.8484 29.0478 12.6871ZM20.9199 30.2807H20.916C19.2024 30.28 17.5218 29.8216 16.0553 28.9558L15.7067 28.7498L12.0921 29.6935L13.0569 26.1862L12.8297 25.8266C11.8737 24.3133 11.3689 22.5643 11.3698 20.7684C11.3717 15.5282 15.656 11.2648 20.9238 11.2648C23.4746 11.2657 25.8725 12.2555 27.6755 14.0521C29.4786 15.8486 30.471 18.2365 30.4701 20.7762C30.4678 26.0169 26.1839 30.2807 20.9199 30.2807ZM26.1584 23.1623C25.8714 23.0192 24.4598 22.3282 24.1965 22.2327C23.9336 22.1374 23.742 22.0899 23.5508 22.3758C23.3593 22.6617 22.8092 23.3054 22.6416 23.496C22.474 23.6867 22.3068 23.7106 22.0196 23.5675C21.7324 23.4246 20.8074 23.1227 19.7107 22.1493C18.8573 21.3917 18.2812 20.456 18.1136 20.1701C17.9463 19.8839 18.1122 19.7442 18.2396 19.587C18.5504 19.2029 18.8616 18.8002 18.9573 18.6097C19.0531 18.4189 19.0051 18.252 18.9332 18.1091C18.8616 17.9661 18.2874 16.5597 18.0482 15.9875C17.815 15.4306 17.5785 15.5058 17.4022 15.497C17.2349 15.4887 17.0434 15.487 16.8519 15.487C16.6606 15.487 16.3495 15.5584 16.0863 15.8447C15.8232 16.1307 15.0816 16.8219 15.0816 18.2282C15.0816 19.6346 16.1103 20.9932 16.2538 21.1839C16.3973 21.3747 18.2784 24.2607 21.1583 25.4981C21.8433 25.7928 22.3779 25.9684 22.795 26.1001C23.4828 26.3176 24.1085 26.2869 24.6033 26.2134C25.155 26.1313 26.3017 25.5221 26.5412 24.8548C26.7804 24.1873 26.7804 23.6153 26.7085 23.496C26.6369 23.3768 26.4454 23.3054 26.1584 23.1623Z"
            fill="white"
          />
        </svg>
      </a>
    </Box>
  );
}
